import {ASSETS_ROOT} from './../../../../../@polygonjs/polygonjs/src/core/loader/AssetsUtils';
import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');

	// import dolphin geo
	const file = geo.createNode('fileOBJ');
	file.p.url.set(`${ASSETS_ROOT}/models/dolphin.obj`);

	// hierarchy to remove the parent and only keep the object with a geometry
	const hierarchy = geo.createNode('hierarchy');
	hierarchy.setInput(0, file);
	hierarchy.p.mode.set(1);

	// scale and rotate the dolphin
	const transform = geo.createNode('transform');
	transform.setInput(0, hierarchy);
	transform.p.scale.set(0.05);
	transform.p.r.y.set(90);

	// create a sphere to instanciate the dolphins onto
	const sphere = geo.createNode('sphere');
	const scatter = geo.createNode('scatter');
	scatter.setInput(0, sphere);
	scatter.p.pointsCount.set(5000);

	// add some jitter
	const jitter = geo.createNode('jitter');
	jitter.setInput(0, scatter);

	// create the instance node
	const instance = geo.createNode('instance');
	instance.setInput(0, transform);
	instance.setInput(1, jitter);
	instance.flags.display.set(true);

	// create a material to render the instance.
	// We only have to extend the existing materials
	const MAT = root.createNode('materialsNetwork');
	MAT.setName('MAT');
	const material = MAT.createNode('meshLambertBuilder');
	const output = material.createNode('output');
	// all we have to do in the material is to plug an instanceTransform node into the output
	const instanceTransform = material.createNode('instanceTransform');
	output.setInput('position', instanceTransform, 'position');
	output.setInput('normal', instanceTransform, 'normal');
	instance.p.material.setNode(material);

	instance.uiData.setComment(
		`This examples demonstrates how to create instances,
which allow to display multiple geometries.

In this case, we are loading a dolphin geometry, which is about 1400 polygons,
and **instancing it 5000 times**.

This gives us about **7 millions polygons**!`
	);

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [instance],
		autoLayout: true,
	};
}

// export const sopInstance = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/instance`,
// 		createData,
// 		categories: [ExampleCategory.INSTANCING],
// 		relatedNodes: [InstanceSopNode],
// 		label: 'Basic',
// 	}),
// 	// new Example({name: `${ExamplePrefix.BY_NODE}/sop/instance/withInputObject`, createData}),
// 	// new Example({name: `${ExamplePrefix.BY_CATEGORY}/instancing`, createData}),
// 	// new Example({name: `${ExamplePrefix.BY_CATEGORY}/instancing/withInputObject`, createData}),
// ];
